import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import logo_white from '../../assets/images/logo_white.png';

const MySwal = withReactContent(Swal);

const successColor = '#1976d2';
const errorColor = '#d32f2f';

const successIcon = 'success';
const errorIcon = 'error';

const successTitle = '¡Correcto!';
const errorTitle = '¡Error!';

const GenericUserAlert = (text, color, icon, title) => {
  MySwal.fire({
    title: '',
    showConfirmButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    html: (
      <div className="alert-success-modal">
        <div className="modal-content">
          <h2>{title}</h2>
          <p>{text}</p>
          <button
            type="button"
            className="continue-btn"
            onClick={() => MySwal.close()}
          >
            Cerrar
          </button>
        </div>
      </div>
    ),
    padding: 0,
    background: 'transparent',
    backdrop: `rgba(0, 0,0,0.8)`,
    customClass: {
      popup: 'custom-success-popup',
    },
    didOpen: () => {

      if (!document.getElementById('alert-success-styles')) {
        const style = document.createElement('style');
        style.id = 'alert-success-styles';
        style.textContent = `
          .alert-popup {
            max-width: 500px !important;
            width: 90% !important;
            border-radius: 20px !important;
            overflow: hidden;
            box-shadow: 0 20px 60px rgba(0,0,0,0.3) !important;
            background: transparent !important;
            padding: 0 !important;
          }

          .alert-success-modal {
            width: 100%;
            height: 400px;
            background-image: url(${logo_white});
            background-size: 180px;
            background-repeat: no-repeat;
            background-position: center 60px;
            border-radius: 20px;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            padding-bottom: 50px;
            box-sizing: border-box;
            font-family: 'Roboto', sans-serif;
            color: white;
            text-align: center;
            background-color: ${color};
          }

          .alert-success-modal .modal-content h2 {
            font-size: 32px;
            margin: 0 0 12px 0;
            font-weight: 700;
          }

          .alert-success-modal .modal-content p {
            font-size: 18px;
            margin: 0 0 30px 0;
            opacity: 0.95;
          }

          .continue-btn {
            background-color: white;
            color: #1976d2;
            border: none;
            border-radius: 50px;
            padding: 14px 40px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            box-shadow: 0 8px 25px rgba(0,0,0,0.2);
            transition: all 0.3s ease;
          }

          .continue-btn:hover {
            transform: translateY(-3px);
            box-shadow: 0 12px 30px rgba(0,0,0,0.3);
          }
        `;
        document.head.appendChild(style);
      }
    },
  });
}

export const UserSuccessAlert = () => {
  const successText = 'Información actualizada exitosamente.';
  GenericUserAlert(successText, successColor, successIcon, successTitle);
};

export const UserErrorAlert = () => {
  const errorText = 'Error al actualizar la información.';
  GenericUserAlert(errorText, errorColor, successIcon, errorTitle);
};

export const UserCreateErrorAlert = () => {
  const errorText = 'Error al crear el usuario.';
  GenericUserAlert(errorText, errorColor, successIcon, errorTitle);
};

export const UserCreateSuccessAlert = () => {
  const successText = 'Usuario creado exitosamente.';
  GenericUserAlert(successText, successColor, successIcon, successTitle);
};

export const UserPasswordSuccessAlert = (text, color ) => {
  GenericUserAlert(text, color, successIcon, successTitle);
};
export const SessionAlert = (text, color ) => {
  GenericUserAlert(text, color, successIcon, 'Ha caducado la sesión');
};